import { getReportDescriptionByType } from "@framework/constants/workbook"
import { WorkbookReportTypeName } from "@framework/types/workbook-report"

export const reportURLToId = (url: string) => {
  return url.split("/").at(-1)
}

export const renderWorkflowQuery = (
  funcName: WorkbookReportTypeName | null,
  argsData: string | Record<string, unknown> | null
) => {
  try {
    const args: Record<string, unknown> = argsData
      ? typeof argsData === "string"
        ? JSON.parse(argsData)
        : argsData
      : null

    const MISSING_ARG_PLACEHOLDER = "[Not provided]"

    if (funcName == null) throw new Error("Unknown Function name")

    if (args == null || !Object.keys(args).length)
      return getReportDescriptionByType(funcName).message

    if (funcName === "PRODUCTPOSITIONING") {
      const {
        alternativeProducts,
        alternateProducts = (alternativeProducts as any[])?.map(
          (it) => it.name
        ),
        application,
      } = args

      const targetProduct =
        typeof args.targetProduct === "string"
          ? args.targetProduct
          : (args.targetProduct as any)?.name

      const altProductsText =
        (alternateProducts as string[])?.join(", ") || MISSING_ARG_PLACEHOLDER

      const targetProductText =
        (targetProduct && targetProduct.toString()) || MISSING_ARG_PLACEHOLDER

      const applicationName =
        (application && application.toString()) || MISSING_ARG_PLACEHOLDER

      return `Generate a Product Positioning report for product ${targetProductText} against products ${altProductsText} in application to ${applicationName}`
    }

    if (funcName === "PRODUCTCOMPARISON") {
      const {
        products,
        productNames = (products as any[])?.map((it) => it.name),
      } = args

      const productsNamesText =
        (productNames as string[])?.join(" vs ") || MISSING_ARG_PLACEHOLDER

      return `Generate a comparison report for ${productsNamesText} products`
    }

    if (funcName === "PRODUCTRECOMMENDATION") {
      const { userContext, context = userContext } = args

      const contextText =
        (context && context.toString()) || MISSING_ARG_PLACEHOLDER
      return `Generate product recommendation report for: ${contextText}`
    }

    if (funcName === "ACCOUNTPLAN") {
      const {
        targetCompanyUrl,
        targetCompanyBu,
        myCompanyUrl,
        additionalContext,
      } = args

      const targetCompanyUrlText =
        (targetCompanyUrl && targetCompanyUrl.toString()) ||
        MISSING_ARG_PLACEHOLDER

      const myCompanyUrlText =
        (myCompanyUrl && myCompanyUrl.toString()) || MISSING_ARG_PLACEHOLDER

      const targetCompanyBuText =
        (targetCompanyBu && targetCompanyBu.toString()) || ""

      const additionalContextText =
        (additionalContext && additionalContext.toString()) || ""

      return `Generate account plan for a company ${targetCompanyUrlText}${
        targetCompanyBuText ? ` at ${targetCompanyBuText}` : ""
      } against my company ${myCompanyUrlText}${
        additionalContextText ? ` with ${additionalContextText}` : ""
      }`
    }

    return getReportDescriptionByType(funcName).message
  } catch (error) {
    console.error(error)
    return "[Unknown workbook report]"
  }
}
